/* eslint-disable import/prefer-default-export */
import { BIControlPanel } from '../interfaces/BIControlPanel';

export const ptBR: BIControlPanel = {
  title: 'Painel de Controle BI',
  tabs: {
    biParamaters: 'Parâmetros BI',
    biApproval: 'Aprovação BI',
  },
  filters: {
    placeholder: 'Selecione',
    noData: 'Nenhum resultado encontrado',
    endText: 'Todos os itens foram carregados',
    expandedTooltip: 'Ocultar opções de pesquisa',
    collapsedTooltip: 'Expandir opções de pesquisa',
    panelExpanded: 'Painel aberto',
    panelCollapsed: 'Painel fechado',
    financialGroupRequired: 'Grupo financeiro*',
    financialGroup: 'Grupo financeiro',
    contract: 'Contrato',
    subcontract: 'Subcontrato',
    carrier: 'Operadora',
    competency: 'Competência',
  },
  table: {
    rowsPerPage: 'Linhas por página',
    of: 'de',
    invoiceValue: 'Valor da fatura',
    invoicePageTotal: 'Total da página',
    status: 'Status',
    active: 'Ativo',
    inactive: 'Inativo',
    lastUpdateDate: 'Data da última atualização',
    updateUser: 'Usuário de atualização',
  },
  messages: {
    parametersPanelLoadError: 'Ocorreu um erro ao carregar o painel de parâmetros.',
    approvalPanelLoadError: 'Ocorreu um erro ao carregar o painel de aprovação.',
    additionalFiltersLoadError: 'Ocorreu um erro ao carregar os filtros adicionais.',
    filterOptionsLoadError: 'Ocorreu um erro ao buscar as opções do filtro.',
    filtersClearError: 'Ocorreu um erro ao limpar os filtros.',
    dataSearchError: 'Ocorreu um erro ao pesquisar os dados.',
    tableDataSearchError: 'Ocorreu um erro ao buscar os dados da tabela do BI.',
    statusUpdateError: 'Ocorreu um erro ao atualizar o status.',
    pageChangeError: 'Ocorreu um erro ao trocar a página.',
    pageSizeChangeError: 'Ocorreu um erro ao alterar a quantidade de linhas.',
  },
};
